<template>
    <aside :class="{ '!right-0 w-276': menuSate }"
        class="pt-4 xl:pt-6 min-h-screen h-full transition-all dark:bg-base-300 duration-300 xl:z-0 z-under-overlay xl:col-span-4 xl:col-span-5 col-span-7 xl:w-80 fixed xl:right-0 top-0 -right-full flex flex-col items-center bg-white">
        <div class="flex justify-between relative items-center ">
            <a href="/" class="  xl:scale-90 scale-75">
                <img :src="logo" width="220" class="flex ">
            </a>
            <!-- <router-link :to="{ name: 'home' }" class="  xl:scale-90 scale-75">
                <img :src="logo" width="220" class="flex ">
            </router-link> -->
            <button @click="setSideBar(false)"
                class="xl:hidden text-biscay-700 dark:text-white absolute bottom-full mb-1 top-0 -left-2.5">
                <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2L9 9M9 9L2 16M9 9L16 16M9 9L2 2" stroke="currentColor" stroke-width="2.88235"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>

            </button>
        </div>

        <div class="md:hidden w-full mt-3 mb-3">
            <div
                class=" font-bold text-gray-800 dark:text-white px-4 py-3 border-t border-b border-biscay-100 border-opacity-20">
                <div class="w-fit-content xl:hidden">
                    <div class=" header__moon items-center" @click="changeTheme('light')" v-if="checkTheme('dark')">
                        <button
                            class="group xl:w-12 flex ml-3 xl:h-12 group w-10 h-10  items-center relative dark:hover:bg-biscay-300 dark:bg-dark-900 justify-center rounded-full bg-gray-210 hover:bg-biscay-700 transition cursor-pointer">
                            <svg width="20" height="21"
                                class=" text-biscay-700 dark:text-white dark:group-hover:text-dark-920 group-hover:text-biscay-300"
                                viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M19.9358 14.3652C20.0691 14.0415 19.9906 13.6679 19.7389 13.4276C19.4872 13.1873 19.115 13.1308 18.8051 13.2857C17.7584 13.8091 16.5801 14.1034 15.3317 14.1034C10.9835 14.1034 7.45846 10.5246 7.45846 6.1098C7.45846 4.32254 8.0352 2.67449 9.01033 1.34372C9.21644 1.06244 9.22917 0.680892 9.04229 0.386091C8.85541 0.0912907 8.50809 -0.054977 8.17055 0.0189828C3.50017 1.04235 2.17361e-07 5.25905 0 10.3077C-2.50276e-07 16.1208 4.64155 20.8333 10.3672 20.8333C14.6778 20.8333 18.372 18.1625 19.9358 14.3652Z"
                                    fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M13.0928 3.67116L13.7596 1.84183C13.9751 1.25035 14.4797 0.939795 14.9987 0.910156C15.5177 0.939795 16.0222 1.25035 16.2378 1.84183L16.9045 3.67116L18.7063 4.34807C19.9329 4.8089 19.9329 6.57032 18.7063 7.03114L16.9045 7.70806L16.2378 9.53738C16.0222 10.1289 15.5177 10.4394 14.9987 10.4691C14.4797 10.4394 13.9751 10.1289 13.7596 9.53738L13.0928 7.70806L11.2911 7.03114C10.0644 6.57032 10.0644 4.8089 11.2911 4.34807L13.0928 3.67116Z"
                                    fill="currentColor"></path>
                            </svg>
                        </button>
                        <span class="dark:text-white  text-dark-920 font-semibold  ">
                            {{ __('Dark mode') }}
                        </span>
                    </div>
                    <div class=" header__sun items-center" @click="changeTheme('automatic')"
                        v-else-if="checkTheme('light')">
                        <button
                            class="group flex xl:w-12 ml-3 xl:h-12 group w-10 h-10  items-center relative dark:hover:bg-biscay-300 dark:bg-dark-920 justify-center rounded-full bg-gray-210 hover:bg-biscay-700 transition cursor-pointer">
                            <svg width="23"
                                class=" text-biscay-700 dark:text-white dark:group-hover:text-dark-920 group-hover:text-biscay-300"
                                height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.8025 18.0871C7.03723 18.0871 5.4658 16.5156 5.51682 11.8013C5.56785 7.08705 7.03723 5.51562 11.8025 5.51562C16.5678 5.51562 18.0882 7.08705 18.0882 11.8013C18.0882 16.5156 16.5678 18.0871 11.8025 18.0871Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M11.8008 0.800781C12.2347 0.800781 12.5865 1.15256 12.5865 1.5865V3.15792C12.5865 3.59186 12.2347 3.94364 11.8008 3.94364C11.3668 3.94364 11.0151 3.59186 11.0151 3.15792V1.5865C11.0151 1.15256 11.3668 0.800781 11.8008 0.800781Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M12.5865 20.4436C12.5865 20.0097 12.2347 19.6579 11.8008 19.6579C11.3668 19.6579 11.0151 20.0097 11.0151 20.4436V22.0151C11.0151 22.449 11.3668 22.8008 11.8008 22.8008C12.2347 22.8008 12.5865 22.449 12.5865 22.0151V20.4436Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M22.8008 11.8008C22.8008 12.2347 22.449 12.5865 22.0151 12.5865H20.4436C20.0097 12.5865 19.6579 12.2347 19.6579 11.8008C19.6579 11.3668 20.0097 11.0151 20.4436 11.0151H22.0151C22.449 11.0151 22.8008 11.3668 22.8008 11.8008Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M3.15792 12.5865C3.59186 12.5865 3.94364 12.2347 3.94364 11.8008C3.94364 11.3668 3.59186 11.0151 3.15792 11.0151H1.5865C1.15256 11.0151 0.800781 11.3668 0.800781 11.8008C0.800781 12.2347 1.15256 12.5865 1.5865 12.5865H3.15792Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M3.38805 3.38805C3.6949 3.08121 4.19238 3.08121 4.49922 3.38805L5.61039 4.49922C5.91723 4.80606 5.91723 5.30355 5.61039 5.61039C5.30355 5.91723 4.80606 5.91723 4.49922 5.61039L3.38805 4.49922C3.08121 4.19238 3.08121 3.6949 3.38805 3.38805Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M4.49922 20.5388C4.19238 20.8457 3.6949 20.8457 3.38805 20.5388C3.08121 20.232 3.08121 19.7345 3.38805 19.4277L4.49922 18.3165C4.80606 18.0097 5.30355 18.0097 5.61039 18.3165C5.91723 18.6233 5.91723 19.1208 5.61039 19.4277L4.49922 20.5388Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M20.5388 3.38805C20.232 3.08121 19.7345 3.08121 19.4277 3.38805L18.3165 4.49922C18.0097 4.80606 18.0097 5.30355 18.3165 5.61039C18.6233 5.91723 19.1208 5.91723 19.4277 5.61039L20.5388 4.49922C20.8457 4.19238 20.8457 3.6949 20.5388 3.38805Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M19.4277 20.5388C19.7345 20.8457 20.232 20.8457 20.5388 20.5388C20.8457 20.232 20.8457 19.7345 20.5388 19.4277L19.4277 18.3165C19.1208 18.0097 18.6233 18.0097 18.3165 18.3165C18.0097 18.6233 18.0097 19.1208 18.3165 19.4277L19.4277 20.5388Z"
                                    fill="currentColor"></path>
                            </svg>
                        </button>
                        <span class="dark:text-white text-dark-920 font-semibold  ">
                            {{ __('Light mode') }}
                        </span>
                    </div>
                    <div class="header__indeterminate items-center" @click="changeTheme('dark')" v-else>
                        <button
                            class="group flex xl:w-12 ml-3 xl:h-12 group w-10 h-10  items-center relative dark:hover:bg-biscay-300 dark:bg-dark-900 justify-center rounded-full bg-gray-210 hover:bg-biscay-700 transition cursor-pointer">
                            <svg class=" text-biscay-700 dark:text-white dark:group-hover:text-dark-920 group-hover:text-biscay-300"
                                height="23" viewBox="0 0 24 24">
                                <path fill="currentColor"
                                    d="M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20V4Z">
                                </path>
                            </svg>
                        </button>
                        <span class="dark:text-white text-dark-920 font-semibold  ">
                            {{ __('System mode') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>


        <div class="overflow-auto sm:h-[calc(100vh-7rem)] h-full w-full sm:mt-8 pb-6 sidebar">
            <ul class="space-y-2">
                <li class="px-4">
                    <router-link
                        class="flex py-3 px-4 items-center group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700 "
                        :to="{ name: 'user.home' }">
                        <HomeIcon class="w-6 h-6 ml-4" />
                        {{ __('Dashboard') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['opportunity.view.all', 'opportunity.view.self'])">
                    <router-link :class="{ 'active': ['user.worktable'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.worktable' }">
                        <Square3Stack3DIcon class="w-6 h-6 ml-4" />
                        {{ __('Worktable') }}
                    </router-link>
                </li>
                <div class="collapse collapse-plus dark:bg-base-300 bg-white"
                    v-if="isPermission(['user.view', 'role.view'])">
                    <input type="checkbox" name="user" @change="toggle" :checked="openIndex == 'user'" />
                    <div
                        class="collapse-title flex px-8 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700">
                        <UsersIcon class="w-6 h-6 ml-4" />
                        {{ __('User management') }}
                    </div>
                    <div class="collapse-content !pb-0">
                        <ul class="bg-base-200 rounded-2xl py-2">
                            <li class="px-4" v-if="isPermission('user.view')">
                                <router-link
                                    :class="{ 'active': ['user.user.create', 'user.user.edit', 'user.user.show'].includes($route.name) }"
                                    class="flex px-4 py-2 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.users' }">
                                    {{ __('All user') }}
                                </router-link>
                            </li>
                            <li class="px-4" v-if="isPermission('role.view')">
                                <router-link
                                    :class="{ 'active': ['user.role.create', 'user.role.edit'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.roles' }">
                                    {{ __('All role') }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <li class="px-4" v-if="isPermission(['person.view.all', 'person.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.person.create', 'user.person.edit', 'user.person.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.persons' }">
                        <UserGroupIcon class="w-6 h-6 ml-4" />
                        {{ __('Person management') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['account.view.all', 'account.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.account.create', 'user.account.edit', 'user.account.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.accounts' }">
                        <IdentificationIcon class="w-6 h-6 ml-4" />
                        {{ __('Account management') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['clue.view.all', 'clue.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.clue.create', 'user.clue.edit', 'user.clue.show','user.clue.convert'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.clues' }">
                        <SignalIcon class="w-6 h-6 ml-4" />
                        {{ __('Clue management') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['sms.view.all', 'sms.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.message.create', 'user.message.edit', 'user.message.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.messages' }">
                        <InboxArrowDownIcon class="w-6 h-6 ml-4" />
                        {{ __('SMS management') }}
                    </router-link>
                </li>
                <div class="collapse collapse-plus dark:bg-base-300 bg-white">
                    <input type="checkbox" name="task" @change="toggle" :checked="openIndex == 'task'" />
                    <div
                        class="collapse-title flex px-8 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700">
                        <CalendarDaysIcon class="w-6 h-6 ml-4" />
                        {{ __('Activity management') }}
                    </div>
                    <div class="collapse-content !pb-0">
                        <ul class="bg-base-200 rounded-2xl py-2">
                            <li class="px-4">
                                <router-link :class="{ 'active': ['user.calendar'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.calendar' }">
                                    {{ __('Calendar') }}
                                </router-link>
                            </li>
                            <li class="px-4" v-if="isPermission(['appointment.view.all', 'appointment.view.self'])">
                                <router-link
                                    :class="{ 'active': ['user.appointment.create', 'user.appointment.edit', 'user.appointment.show'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.appointments' }">
                                    {{ __('All activities') }}
                                </router-link>
                            </li>
                        </ul>

                    </div>
                </div>
                <li class="px-4" v-if="isPermission(['invoice.view.all', 'invoice.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.invoice.create', 'user.invoice.edit', 'user.invoice.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.invoices' }">
                        <ClipboardDocumentListIcon class="w-6 h-6 ml-4" />
                        {{ __('Invoice management') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['campaign.view.all', 'campaign.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.campaign.create', 'user.campaign.edit', 'user.campaign.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.campaigns' }">
                        <MegaphoneIcon class="w-6 h-6 ml-4" />
                        {{ __('Campaign management') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['opportunity.view.all', 'opportunity.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.opportunity.create', 'user.opportunity.edit', 'user.opportunity.show'].includes($route.name) }"
                        class="flex px-4 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.opportunities' }">
                        <LightBulbIcon class="w-6 h-6 ml-4" />
                        {{ __('Opportunity management') }}
                    </router-link>
                </li>
                                <li class="px-4">
                    <router-link :class="{ 'active': ['user.ticket.create', 'user.ticket.show'].includes($route.name) }"
                        class="flex py-3 px-4 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.tickets' }">
                        <TicketIcon class="w-6 h-6 ml-4" /> {{ __('Support ticket') }}
                    </router-link>
                </li>
                <li class="px-4" v-if="isPermission(['discount.view.all', 'discount.view.self'])">
                    <router-link
                        :class="{ 'active': ['user.discount.create', 'user.discount.edit', 'user.discount.show'].includes($route.name) }"
                        class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                        :to="{ name: 'user.discounts' }">
                        <ReceiptPercentIcon class="w-6 h-6 ml-4" />
                        {{ __('All discounts') }}
                    </router-link>
                </li>
                <div class="collapse collapse-plus dark:bg-base-300 bg-white">
                    <input type="checkbox" name="statistic" @change="toggle" :checked="openIndex == 'statistic'" />
                    <div
                        class="collapse-title flex px-8 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700">
                        <ChartBarIcon class="w-6 h-6 ml-4" />
                        {{ __('Reports') }}
                    </div>
                    <div class="collapse-content !pb-0">
                        <ul class="bg-base-200 rounded-2xl py-2">
                            <li class="px-4">
                                <router-link :class="{ 'active': $route.params.type == 'lead-source' }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.statistic', params: { type: 'lead-source' } }">
                                    {{ __('Lead Sources') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': $route.params.type == 'failure-reason' }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.statistic', params: { type: 'failure-reason' } }">
                                    {{ __('Failure reasons') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': $route.params.type == 'campaign' }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.statistic', params: { type: 'campaign' } }">
                                    {{ __('Campaigns') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': $route.params.type == 'product-sale' }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.statistic', params: { type: 'product-sale' } }">
                                    {{ __('Product sales') }}
                                </router-link>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="collapse collapse-plus dark:bg-base-300 bg-white" v-if="isPermission(['setting.view'])">
                    <input type="checkbox" name="setting" :checked="openIndex == 'setting'" @change="toggle" />
                    <div
                        class="collapse-title flex px-8 py-3 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700">
                        <Cog8ToothIcon class="w-6 h-6 ml-4" />
                        {{ __('Settings') }}
                    </div>
                    <div class="collapse-content !pb-0">
                        <ul class="bg-base-200 rounded-2xl py-2">
                            <li class="px-4" v-if="auth.user.is_super">
                                <router-link :class="{ 'active': ['user.settings'].includes($route.name) }"
                                    class="flex px-4 py-2 group text-17 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.settings' }">
                                    {{ __('General settings') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': ['user.save.messages'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.save.messages' }">
                                    {{ __('Ready messages') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link
                                    :class="{ 'active': ['user.sale.route.create', 'user.sale.route.edit', 'user.sale.route.show'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.sale.routes' }">
                                    {{ __('Sale routes') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': ['user.failure.reasons'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.failure.reasons' }">
                                    {{ __('Failure reasons') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': ['user.lead.sources'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.lead.sources' }">
                                    {{ __('Lead Sources') }}
                                </router-link>
                            </li>
                            <li class="px-4" v-if="isPermission(['setting.view', 'setting.view'])">
                                <router-link
                                    :class="{ 'active': ['user.product.create', 'user.product.edit', 'user.product.show'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.products' }">
                                    {{ __('Products') }}
                                </router-link>
                            </li>
                            <li class="px-4" v-if="isPermission(['setting.view', 'setting.view'])">
                                <router-link
                                    :class="{ 'active': ['user.product.category.create', 'user.product.category.edit', 'user.product.category.show'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.product.categories' }">
                                    {{ __('Product Categories') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link :class="{ 'active': ['user.campaign.types'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.campaign.types' }">
                                    {{ __('Campaign types') }}
                                </router-link>
                            </li>
                            <li class="px-4">
                                <router-link
                                    :class="{ 'active': ['user.industry.create', 'user.industry.edit', 'user.industry.show'].includes($route.name) }"
                                    class="flex px-4 group text-17 py-2 font-medium text-gray-800 dark:text-white dark:hover:text-blue-450  transform transition hover:text-blue-700"
                                    :to="{ name: 'user.industries' }">
                                    {{ __('Industries') }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

            </ul>
        </div>

    </aside>
</template>
<script setup>
import { SignalIcon, MegaphoneIcon, ChartBarIcon, TicketIcon, Cog8ToothIcon, InboxArrowDownIcon, ClipboardDocumentListIcon, Square3Stack3DIcon, CalendarDaysIcon, CreditCardIcon, LightBulbIcon, ReceiptPercentIcon, IdentificationIcon, UserGroupIcon, HomeIcon, UsersIcon } from '@heroicons/vue/24/outline';
defineProps(['logo']);
const emit = defineEmits(['setSideBar']);
const { theme, setTheme, route } = useHome();
const menuSate = inject('menuSate');
const auth = useAuthStore();
const openIndex = ref();
const toggle = (e) => {
    const name = e.target.name;
    openIndex.value = openIndex.value === name ? null : name;
};
const getCollapsed = () => {
    const name = route.name;
    let index = null;
    if (['user.users', 'user.user.create', 'user.user.edit', 'user.user.show', 'user.roles', 'user.role.create', 'user.role.edit'].includes(name)) index = "user";
    else if (['user.calendar', 'user.tasks', 'user.task.create', 'user.task.edit', 'user.task.show', 'user.appointments', 'user.appointment.create', 'user.appointment.edit', 'user.appointment.show', 'user.contacts', 'user.contact.create', 'user.contact.edit', 'user.contact.show'].includes(name)) index = "task";
    else if (['user.settings', 'user.industries', 'user.industry.create', 'user.industry.edit', 'user.industry.show', 'user.lead.sources',
        'user.save.messages', 'user.sale.routes', 'user.sale.route.create', 'user.sale.route.edit', 'user.sale.route.show', 'user.campaign.types', 'user.failure.reasons'
    ].includes(name)) index = 'setting';
    else if (['user.statistic'].includes(name)) index = 'statistic';
    return index;
}
openIndex.value = getCollapsed()
const setSideBar = (show = true) => emit('setSideBar', show);
const checkTheme = (value) => theme.value === value;
const changeTheme = (value) => {
    theme.value = value;
    setTheme();
}
const handleLinkClick = (e) => {
  if (e.target.tagName.toLowerCase() === "a") {
    if (!e.target.closest(".collapse")) {
      openIndex.value = null;
    }
  }
};
onMounted(() => {
  document.querySelector(".sidebar").addEventListener("click", handleLinkClick);
});
const isPermission = (permission) => window.isPermission(permission);
</script>